import transactionsApi from '../_api'
export default {
  data () {
    return {
      updateTransactionIntervalId: null
    }
  },
  computed: {
    receipts () {
      return this.transaction?.receipt?.receiptMedia ? this.transaction.receipt.receiptMedia : this.expensesReceipts
    },
    isProcessingReceipts () {
      return this.receipts.some(item => !item.processed)
    },
    hasAnyTaxFieldFilled () {
      return Object.values(this.taxes).some(el => el.taxBase > 0)
    }
  },
  methods: {
    setIntervalTransaction () {
      if (this.updateTransactionIntervalId !== null) return
      this.updateTransactionIntervalId = setInterval(() => {
        this.updateExpenseReceipt()
      }, 6000)
    },
    clearIntervalTransaction () {
      clearInterval(this.updateTransactionIntervalId)
    },
    updateExpenseReceipt () {
      if (!this.transaction.id) return
      transactionsApi.getTransaction(this.transaction.id).then((response) => {
        const { data } = response
        this.receipt.receiptOcrs = data?.receipt?.receiptOcrs
        this.receipt.receiptOcrDevoluiva = data?.receipt?.receiptOcrDevoluiva
        this.receipt.receiptMedia = data?.receipt.receiptMedia
        if (this.transaction && this.transaction.receipt && this.transaction.receipt.receiptMedia) this.transaction.receipt.receiptMedia = data?.receipt.receiptMedia

        if (this.expense && !this.expense?.amount && data.amount !== null && data.amount !== 0) this.expense.amount = data.amount

                if (!this.transaction?.amount && data.amount !== null && data.amount !== 0) {
          this.transaction.amount = data.amount
          this.amountOriginalCurrency = data.amount

          this.$forceUpdate()
                }

        // if (!this.amountOriginalCurrency && data.amount !== null && data.amount !== 0) this.amountOriginalCurrency = data.amount

        // if (this.selectedVatRegion.id !== data.receipt?.receiptOcrs[0].vatTypeAssigned?.id) this.selectedVatRegion = { ...data.receipt?.receiptOcrs[0].vatTypeAssigned }
        if (this.expense && !this.expense.date && data.expense.date) this.expense.date = data.expense.date
        if (this.transaction && !this.transaction.date && data.expense.date) this.transaction.date = data.expense.date

        if (!this.receipt.receiptNumber && data.receipt.receiptNumber) this.receipt.receiptNumber = data.receipt.receiptNumber

        if (!this.receipt.providerData && data.receipt.providerData) this.receipt.providerData = data.receipt.providerData
        if (!this.receipt.provider && data.receipt.provider) this.receipt.provider = data.receipt.provider

        if (!this.receipt.country && data.receipt.country) this.receipt.country = data.receipt.country

        if (!this.receipt.state && data.receipt.state) this.receipt.state = data.receipt.state
        if (!this.receipt.zipCode && data.receipt.zipCode) this.receipt.zipCode = data.receipt.zipCode
        if (!this.receipt.city && data.receipt.city) this.receipt.city = data.receipt.city
        if (!this.receipt.address && data.receipt.address && data.receipt.address !== '' && data.receipt.address !== ' ') this.receipt.address = data.receipt.address
        this._handleTaxesOcrInitialization(data.receipt?.receiptOcrs[0])

        this.calculateOptions()
      })
    },
    _handleTaxesOcrInitialization (receiptOcr) {
      if (!this.hasAnyTaxFieldFilled) {
        this.taxes.vatType1.taxBase = receiptOcr.taxBase1
        this.taxes.vatType2.taxBase = receiptOcr.taxBase2
        this.taxes.vatType3.taxBase = receiptOcr.taxBase3
        this.taxes.vatType4.taxBase = receiptOcr.taxBase4
        this.taxes.vatType5.taxBase = receiptOcr.taxBase5
        this.taxes.vatType6.taxBase = receiptOcr.taxBase6

        this.taxes.vatType1.vatType = receiptOcr.vatType1
        this.taxes.vatType3.vatType = receiptOcr.vatType3
        this.taxes.vatType2.vatType = receiptOcr.vatType2
        this.taxes.vatType4.vatType = receiptOcr.vatType4
        this.taxes.vatType5.vatType = receiptOcr.vatType5
        this.taxes.vatType6.vatType = receiptOcr.vatType6

        this.taxes.vatType1.vat = receiptOcr.vat1
        this.taxes.vatType2.vat = receiptOcr.vat2
        this.taxes.vatType3.vat = receiptOcr.vat3
        this.taxes.vatType4.vat = receiptOcr.vat4
        this.taxes.vatType5.vat = receiptOcr.vat5
        this.taxes.vatType6.vat = receiptOcr.vat6
      }
    }
  },
  destroyed () {
    clearInterval(this.updateTransactionIntervalId)
  }
}
